import { render, staticRenderFns } from "./PageSubmenu.vue?vue&type=template&id=487c9dc1"
import script from "./PageSubmenu.vue?vue&type=script&lang=js"
export * from "./PageSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports